export const AI_AGENTS_TAB_ENABLED = import.meta.env.VITE_ENABLE_AI_AGENTS_TAB === "true";

/** Finance AI chat with persisted history (Nest `AiChatModule`; UI route `/finance-agent`). */
export const AI_CHAT_TAB_ENABLED = import.meta.env.VITE_ENABLE_AI_CHAT_TAB === "true";
